import AuthStorage from "../utils/AuthStorage";
import { fetchApi } from "../utils/fetch-api";

export class AuthApi {
  static async checkUsername({ username }) {
    let headers = {};
    try {
      const data = fetchApi({
        url: `/api/v1/auth/check-username?username=${username}`,
        options: {
          method: "GET",
          headers,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async setUsername(payload) {
    let headers = {};
    try {
      const data = fetchApi(
        {
          url: "/api/v1/auth/wall",
          options: {
            method: "POST",
            headers,
          },
          payload,
        },
        (err, response) => {
          localStorage.removeItem("temp_txn_data");
          localStorage.removeItem("latest_explorer_check");
          if (err) return;
          if (response.status !== true) return;
          if (response.two_factor) {
            const {
              token: two_f_token,
              two_factor,
              two_factor_type,
            } = response;
            AuthStorage.value = {
              two_factor,
              two_f_token,
              two_factor_type,
            };
          } else if (response?.data) {
            const [addr1, addr2, addr3] =
              response?.data?.wallets?.pulsar_data?._addresses?.reverse();
            const balance = response?.data?.wallets?.pulsar_data?.balance;
            AuthStorage.value = {
              token: response?.data?.token,
              user: response?.data?.user,
              wallets: {
                pulsar_data: { _addresses: [addr3, addr2, addr1], balance },
              }, // address order is important
            };
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async signUp(payload) {
    let headers = {};
    payload.type === "multipart"
      ? (headers["Content-Type"] = "multipart/form-data")
      : (headers = {});
    try {
      const data = await fetchApi({
        url: "/api/v1/auth/register",
        options: {
          method: "POST",
          headers,
        },
        payload: payload.values,
      });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async explorerRecords(payload) {
    let headers = {};
    try {
      const data = await fetchApi({
        url: "/api/v1/wallet/plsr/explorer-records",
        options: {
          method: "GET",
          headers,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async login(payload) {
    let headers = {};
    payload.type === "multipart"
      ? (headers["Content-Type"] = "multipart/form-data")
      : (headers = {});
    try {
      const data = await fetchApi(
        {
          url: "/api/v1/auth/login",
          options: {
            method: "POST",
            headers,
          },
          payload: payload.values,
        },
        (err, response) => {
          localStorage.removeItem("temp_txn_data");
          localStorage.removeItem("latest_explorer_check");
          if (err) return;
          if (response.status !== true) return;
          if (response.two_factor) {
            const {
              token: two_f_token,
              two_factor,
              two_factor_type,
            } = response;
            AuthStorage.value = {
              two_factor,
              two_f_token,
              two_factor_type,
            };
          } else if (response?.data) {
            const [addr1, addr2, addr3] =
              response?.data?.wallets?.pulsar_data?._addresses?.reverse();
            const balance = response?.data?.wallets?.pulsar_data?.balance;
            AuthStorage.value = {
              token: response?.data?.token,
              user: response?.data?.user,
              wallets: {
                pulsar_data: { _addresses: [addr3, addr2, addr1], balance },
              }, // address order is important
            };
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async confirmMail({ values: { tk, em } }) {
    try {
      const headers = {};
      const data = await fetchApi(
        {
          url: `/api/v1/auth/confirm-mail?tk=${tk}&em=${em}`,
          options: {
            method: "GET",
            headers,
          },
        },
        (err, response) => {
          localStorage.removeItem("temp_txn_data");
          localStorage.removeItem("latest_explorer_check");
          if (!err) {
            if (response.status === true) {
              AuthStorage.sessionDestroy();
              AuthStorage.value = {
                token: response?.data?.token,
                user: response?.data?.user,
                wallets: response?.data?.wallets,
              };
            }
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async twoFactorSetup({ authType, value }) {
    try {
      const headers = {};
      const data = await fetchApi(
        {
          url: `/api/v1/auth/two-factor/send-2fa/${
            authType === "email" ? "em" : "ph"
          }?${authType === "email" ? "email" : "phoneNo"}=${value}`,
          options: {
            method: "GET",
            headers,
          },
        },
        (err, response) => {}
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async twoFactorConfirmation({ authType, value, token }) {
    try {
      const headers = {};
      if (token || AuthStorage.value.two_f_token) {
        headers.authorization = `Bearer ${
          token || AuthStorage.value.two_f_token
        }`;
      }
      const data = await fetchApi(
        {
          url: `/api/v1/auth/two-factor/${
            authType === "email" ? "email" : "phoneNo"
          }/confirm-2fa?two_factor_otp=${value}`,
          options: {
            method: "GET",
            headers,
          },
        },
        (err, response) => {
          localStorage.removeItem("temp_txn_data");
          localStorage.removeItem("latest_explorer_check");
          if (!err) {
            const [addr1, addr2, addr3] =
              response?.data?.wallets?.pulsar_data?._addresses?.reverse();
            const balance = response?.data?.wallets?.pulsar_data?.balance;
            AuthStorage.sessionDestroy();
            AuthStorage.value = {
              ...AuthStorage.value,
              user: response.data?.user,
              wallets: {
                pulsar_data: { _addresses: [addr3, addr2, addr1], balance },
              }, // address order is important
              token: response.data?.token,
            };
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async pulsar() {
    try {
      const headers = {};
      const data = await fetchApi(
        {
          url: "/api/v1/wallet/plsr",
          options: {
            method: "GET",
            headers,
          },
        },
        (err, response) => {
          if (!err) {
            const [addr1, addr2, addr3] = response?.data?.addresses?.reverse();
            const balance = response?.data?.balance;
            AuthStorage.value = {
              ...AuthStorage.value,
              wallets: {
                pulsar_data: { _addresses: [addr3, addr2, addr1], balance },
              }, // address order is important
            };
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async generateAddress() {
    try {
      const headers = {};
      const data = await fetchApi({
        url: "/api/v1/wallet/plsr/address",
        options: {
          method: "GET",
          headers,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async sendPulsar(payload) {
    let headers = {};
    payload.type === "multipart"
      ? (headers["Content-Type"] = "multipart/form-data")
      : (headers = {});
    try {
      const data = await fetchApi({
        url: "/api/v1/wallet/plsr/transactions",
        options: {
          method: "POST",
          headers,
        },
        payload: payload.values,
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getTransactions() {
    try {
      const data = await fetchApi({
        url: "/api/v1/wallet/plsr/transactions/10",
        options: {
          method: "GET",
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getExplorerData() {
    try {
      const data = await fetchApi({
        url: "/api/v1/wallet/plsr/explorer",
        options: {
          method: "GET",
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async resetPass(email) {
    try {
      const data = await fetchApi({
        url: `/api/v1/auth/forgot-password?email=${email}`,
        options: {
          method: "GET",
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async changePass(payload) {
    try {
      let headers = {};
      payload.type === "multipart"
        ? (headers["Content-Type"] = "multipart/form-data")
        : (headers = {});
      const data = await fetchApi({
        url: "/api/v1/auth/change-password",
        options: {
          method: "PUT",
          headers,
        },
        payload,
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async searchPulsar(payload) {
    try {
      const data = await fetchApi({
        url: `/api/v1/wallet/plsr/search?keyword=${payload.keyword}`,
        options: {
          method: "GET",
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async confirmResetPass(payload) {
    let headers = {};

    payload.type === "multipart"
      ? (headers["Content-Type"] = "multipart/form-data")
      : (headers = {});
    try {
      const data = await fetchApi({
        url: "/api/v1/auth/forgot-password",
        options: {
          method: "PUT",
          headers,
        },
        payload: payload.values,
      });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async logout() {
    try {
      const data = await fetchApi(
        {
          url: "/api/v1/auth/logout",
          options: {
            method: "GET",
          },
        },
        (err, response) => {
          if (!err) {
            AuthStorage.sessionDestroy();
            localStorage.removeItem("temp_txn_data");
            localStorage.removeItem("latest_explorer_check");
            localStorage.removeItem("expiresIn");
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async logoutAllSessions() {
    try {
      const data = await fetchApi(
        {
          url: "/api/v1/auth/logout-all-sessions",
          options: {
            method: "GET",
          },
        },
        (err, response) => {
          if (!err) {
            AuthStorage.sessionDestroy();
            localStorage.removeItem("temp_txn_data");
            localStorage.removeItem("latest_explorer_check");
            localStorage.removeItem("expiresIn");
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
}
